import store from "@/store";

export default {
  getStats(surveyId) {
    return store.state.api.get(`get_stats/${surveyId}`);
  },

  getWeeklySurveys() {
    return store.state.api.get(`get_weekly_surveys/`);
  }
};
